import(/* webpackMode: "eager", webpackExports: ["SignUpPage"] */ "/home/runner/work/33m2-front/33m2-front/src/pages/sign-up/ui/page.tsx");
